import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { CONTEXT_MENU_ACTION_NAMES } from 'components/move-list/components/context-menu/config/context-menu-action-names';
import { MoveList } from 'chessboard/model/move-list/types';
import { Core } from 'chessboard/core/config/types';
import { createCoreEvent } from 'chessboard/core/model/create-core-event';

/**
 * Create set focus node limit action
 */
export function createSetBegin(store: Store, storeActions: StoreActions): ContextMenu.Action {
  return {
    getDisplayName: () => MoveList.Translation.Actions.SetBegin,
    action: CONTEXT_MENU_ACTION_NAMES.SetBegin,
    isVisible,
    handler,
  };

  /**
   * Determine if the action is visible
   */
  function isVisible({ node }: ContextMenu.ActionHandlerContext): boolean {
    const { enabled, begin } = store.nodeLimits.get();

    return enabled && begin !== node.ids;
  }

  /**
   * Handle the action
   */
  function handler({ node, game }: ContextMenu.ActionHandlerContext) {
    const nodeLimit = { begin: node.ids };
    const event = createCoreEvent(Core.APIEvents.NodeLimitsUpdated, nodeLimit);

    game.emit(Core.APIEvents.NodeLimitsUpdated, event);
    storeActions.setNodeLimits(nodeLimit);
  }
}
